import { atom, useRecoilValue, useSetRecoilState, useResetRecoilState } from 'recoil';
import { SignInState, UseSignInState, UseUpdateSignInState } from './sign-in.types';

export const signInState = atom<SignInState>({
  default: {
    remoteValidationError: '',
    signInStatus: 'SIGN_IN',
    username: '',
  },
  key: 'signInState',
});

export const useSignInState = (): UseSignInState => useRecoilValue(signInState);

export const useUpdateSignInState = (): UseUpdateSignInState => {
  const state = useSignInState();
  const setState = useSetRecoilState(signInState);
  const reset = useResetRecoilState(signInState);

  return {
    backToSignIn: reset,
    errorSignIn: () => setState(state => ({ ...state, signInStatus: 'SIGN_IN_ERROR' })),
    forbiddenSignIn: () => setState(state => ({ ...state, signInStatus: 'SIGN_IN_FORBIDDEN' })),
    setRemoteValidationError: (remoteValidationError: string = '') => {
      if (state.remoteValidationError !== remoteValidationError) {
        setState(state => ({ ...state, remoteValidationError }));
      }
    },
    setUserName: (username: string) => setState(state => ({ ...state, username })),
    successEmailSend: () => setState(state => ({ ...state, signInStatus: 'SUCCESS_EMAIL_SEND' })),
  };
};
